module.exports = __webpack_public_path__ + "img/9788983925589.e9915151.jpg";